import { artistRepsInviteUrl } from '../urls';
import refresh from '../refresh';

export async function postArtistRepInvite(email, validTo, canEdit, canSign) {
  const data = {
    email,
    validTo,
    canEdit,
    canSign,
  };
  return refresh(async () => {
    const response = await fetch(artistRepsInviteUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}

export async function deleteArtistRepInvite(inviteId) {
  const data = {
    invite: inviteId,
  };
  return refresh(async () => {
    const response = await fetch(artistRepsInviteUrl, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
